import { default as BodyComponent } from './BodyComponent';
import { default as FullWidthComponent } from './FullWidthComponent';

export { BodyComponent, FullWidthComponent };
